import { Trans } from 'react-i18next';
import { toast } from 'react-toastify';

import SVGRenderer from 'root/components/Icon/SVGRenderer';

// icon is using fontawesome, please refer to this link if want to change
// https://react-icons.github.io/react-icons/icons?name=fa
const userVerificationAlert = {
    showNotification(type, content, specialToastParam = null) {
        let toastContent = userVerificationAlert.renderToast(type, content);

        // special toast configuration
        // please refer https://fkhadra.github.io/react-toastify/api/toast
        // for which item to config
        if (specialToastParam) {
            toast(toastContent, specialToastParam);
        } else {
            toast(toastContent);
        }
    },

    getCorrectIcon(type) {
        switch (type) {
            case 'success':
                return <SVGRenderer category={'SVGReactIcons'} width='1em' height='1em' name='FaCheckCircle' className='success' />;
            case 'error':
                return <SVGRenderer category={'SVGReactIcons'} width='1em' height='1em' name='FaRegTimesCircle' className='error' />;
            case 'warning':
                return <SVGRenderer category={'SVGReactIcons'} width='1em' height='1em' name='FaExclamation' className='warning' />;
            case 'info':
            default:
                return <SVGRenderer category={'SVGReactIcons'} width='1em' height='1em' name='FaInfoCircle' className='info' />;
        }
    },

    renderToast(type, content) {
        return (
            <div className={`standard-notification-container user-verification-container`}>
                <div className='standard-notification-icon'>{userVerificationAlert.getCorrectIcon(type)}</div>

                <div className={`standard-notification-content ${type}`}>
                    <Trans defaults={content}></Trans>
                </div>

                <button className={`standard-notification-btn`}>
                    <Trans defaults={'global:entity.action.ok2'}></Trans>
                </button>
            </div>
        );
    },
};

export default userVerificationAlert;
